import req from './../../fetch';
import { undocumentedResponse } from './../../utils';
import {
  AllAPIResponses,
  ApplicationType,
  CarbonError,
  CarbonQueryBodyType,
  CarbonQueryResult,
} from './../../index';
type ResultType = CarbonQueryResult<ApplicationType>;

const post = async (
  payload: CarbonQueryBodyType,
  headers?: Headers
): Promise<AllAPIResponses<ResultType>> => {
  try {
    const resp = await req.post(
      '/api/applications',
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
      case 204:
        return {
          data: (await resp.json()) as ResultType,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
